module.exports = __webpack_public_path__ + "img/call-icon.2c9017d6.svg";